import React from "react";
import { FormControlLabel, Switch, Typography, Box } from "@mui/material";

const ToggleSwitchWithLabel = ({ label, checked, onChange, name, ...props }) => {
  return (
    <Box sx={{ mb: 1 }}>
      <FormControlLabel
        control={
          <Switch
            name={name}
            checked={!!checked} 
            onChange={onChange}
            color="primary"
            {...props}
          />
        }
        label={<Typography variant="body2">{label}</Typography>}
      />
    </Box>
  );
};

export default ToggleSwitchWithLabel;